<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-merge-presenter
    [merge]="merge$ | async"
    [tasks] = 'tasks$ | async'
    [serviceItems] = 'serviceItems$ | async'
    (Merge)="onMerge($event)"
></ef-merge-presenter>
